import axios from "axios";
import { setToast } from "../../util/toast";
import * as ActionType from "./language.type";
import { apiInstanceFetch } from "../../util/api";

// Get all languages
export const getLanguage = () => (dispatch) => {
  apiInstanceFetch
    .get("language/")
    .then((res) => {
      console.log("GET LANGUAGE RESPONSE 👉", res); // check response
      if (res.status) {
        dispatch({
          type: ActionType.GET_LANGUAGE,
          payload: res.data, // backend me 'data' array hai
        });
      } else {
        setToast("error", res.message || "Failed to fetch languages");
      }
    })
    .catch((err) => {
      console.error("GET LANGUAGE ERROR 👉", err);
      setToast("error", err.message || "Something went wrong");
    });
};

// Create language
export const createLanguage = (data) => (dispatch) => {
  axios
    .post("/language", data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.CREATE_LANGUAGE,
          payload: res.data.data, // backend returns created language
        });
        setToast("success", "Language added successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((err) => console.log(err.message));
};

// Edit language
export const editLanguage = (data, id) => (dispatch) => {
  axios
    .patch(`/language/${id}`, data)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.UPDATE_LANGUAGE,
          payload: { data: res.data.data, id },
        });
        setToast("success", "Language updated successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((err) => console.log(err.message));
};

// Delete language
export const deleteLanguage = (id) => (dispatch) => {
  axios
    .delete(`/language/${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: ActionType.DELETE_LANGUAGE,
          payload: id,
        });
        setToast("success", "Language deleted successfully");
      } else {
        setToast("error", res.data.message);
      }
    })
    .catch((err) => console.log(err.message));
};
